import * as React from 'react';
import { PropertyGuides } from '../PropertyGuides';
import { EPageKind } from '../../types/page';
import { ITopJK, ITopThreeItem } from '../../types/top_three';
import { MortgageLandingContainer } from '../../containers/MortgageLandingContainer';
import { RecommendedContainer } from '../recommended_list';
import { SeoContainer } from '../../containers/seo_container';
import { FiltersContainer } from '../filters_container/filters_container';
import { Specialists } from '../../containers/specialists/specialists';
import { VacanciesContainer } from '../../containers/vacancies/vacancies';
import { VerticalPromo } from '../../containers/vertical_promo/vertical_promo';
import { CommercialPromo } from '../../containers/commercial_promo/commercial_promo';
import { TwoColumnContainer } from '../two_column_container/two_column_container';
import { NewBuildingsServices } from '../../containers/new_buildings_service/new_buildings_services';
import { MagazineContainer } from '../../containers/magazine/magazine';
import { Filters } from '../../containers/search_block/filters';
import { SaleServices } from '../../containers/sale_services/sale_services';
import { Promo } from '../../containers/promo/promo';
import { PopularList } from '../../containers/popular_list/popular_list';
import { JKPopularList } from '../../containers/popular_jk/popular_jk';
import { NewBuildingCaption } from '../../containers/new_building_caption/new_building_caption';

export interface IHomeComponentProps {
  pageKind: EPageKind;
  isMortgageTabActive: boolean;
  isFetching: boolean;
  top3?: ITopThreeItem[];
  popularJks?: ITopJK[];
  recommendationExperimentGroup: number | null;
  isPropertyGuidesVisible: boolean;
}

export interface IHomeProps {
  section: string;
}

export class HomeComponent extends React.Component<IHomeComponentProps & IHomeProps> {
  public renderPromo() {
    switch (this.props.section) {
      case 'index':
        return <Promo />;
      case 'daily-rent':
      case 'sale':
      case 'rent':
      case 'new-buildings':
        return <VerticalPromo />;
      case 'commercial':
        return <CommercialPromo />;
      default:
        return null;
    }
  }

  public renderServices() {
    switch (this.props.section) {
      case 'daily-rent':
      case 'commercial':
      case 'sale':
      case 'rent':
        return <SaleServices />;
      case 'new-buildings':
        return <NewBuildingsServices />;
      case 'index':
      default:
        return null;
    }
  }

  public renderPopular() {
    if (this.props.section === 'new-buildings') {
      return <JKPopularList services={this.renderServices()} />;
    } else {
      return <PopularList showLinkToAll={this.props.section !== 'index'} services={this.renderServices()} />;
    }
  }

  public render() {
    const {
      pageKind,
      section,
      recommendationExperimentGroup,
      isPropertyGuidesVisible,
      isMortgageTabActive,
      isFetching,
    } = this.props;
    const isIndexSection = section === 'index';
    const isRecommendationExperiment =
      recommendationExperimentGroup === 1 || recommendationExperimentGroup === 2 || recommendationExperimentGroup === 3;

    if (isFetching) {
      return null;
    }

    if (isMortgageTabActive) {
      return (
        <div>
          <FiltersContainer>
            <NewBuildingCaption section={section} />
            <Filters section={section} />
          </FiltersContainer>
          <MortgageLandingContainer />
        </div>
      );
    } else {
      return (
        <div>
          <FiltersContainer>
            <NewBuildingCaption section={section} />
            <Filters section={section} />
          </FiltersContainer>

          {isPropertyGuidesVisible && <PropertyGuides pageKind={pageKind} />}

          {isIndexSection && isRecommendationExperiment && (
            <RecommendedContainer experimentGroup={recommendationExperimentGroup} />
          )}

          {this.renderPromo()}

          <TwoColumnContainer wideRow={section === 'commercial'} popularPresented={this.popularPresented()}>
            {this.renderPopular()}
            <Specialists section={section} popularPresented={this.popularPresented()} />
          </TwoColumnContainer>

          {isIndexSection && (
            <>
              <MagazineContainer />
              <VacanciesContainer />
            </>
          )}

          <SeoContainer />
        </div>
      );
    }
  }

  private popularPresented() {
    return (
      (!!this.props.top3 && this.props.top3.length > 0) || (!!this.props.popularJks && this.props.popularJks.length > 0)
    );
  }
}
